import { AppRoute } from 'src/core/AppRoute';

/* Account Route */
export const ROUTE_ACCOUNT = new AppRoute('/account', 'account');

/* Data */
export const ROUTE_ACCOUNT_DATA = ROUTE_ACCOUNT.sub('data', 'account_data', { icon: 'person' });
export const ROUTE_ACCOUNT_DATA_MAIN = ROUTE_ACCOUNT_DATA.sub('main', 'account_data_main');
export const ROUTE_ACCOUNT_DATA_DOCUMENTS = ROUTE_ACCOUNT_DATA.sub('documents', 'account_data_documents');
export const ROUTE_ACCOUNT_DATA_ADDRESSES = ROUTE_ACCOUNT_DATA.sub('addresses', 'account_data_addresses');
export const ROUTE_ACCOUNT_DATA_PAYMENTS = ROUTE_ACCOUNT_DATA.sub('payments', 'account_data_payments');
export const ROUTE_ACCOUNT_DATA_FEEDBACK = ROUTE_ACCOUNT_DATA.sub('feedback', 'account_data_feedback');
export const ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM = ROUTE_ACCOUNT_DATA.sub(
    'premium-program',
    'account_data_premium_program'
);

/* Messages (customer-visible notes, F-KD-02) */
export const ROUTE_ACCOUNT_MESSAGES = ROUTE_ACCOUNT.sub('messages', 'account_messages', { icon: 'mail' });

/* Orders */
export const ROUTE_ACCOUNT_ORDERS = ROUTE_ACCOUNT.sub('orders', 'account_orders', { icon: 'shopping_bag' });

/* Offers */
export const ROUTE_ACCOUNT_OFFERS = ROUTE_ACCOUNT_ORDERS.sub('offers', 'account_offers', {
    accessPrivilege: ['office_profi'],
});

/* Credits */
export const ROUTE_ACCOUNT_CREDITS = ROUTE_ACCOUNT.sub('credits', 'account_credits', { icon: 'savings' });

/* Landingpages */
export const ROUTE_ACCOUNT_LANDINGPAGES = ROUTE_ACCOUNT.sub('landingpages', 'account_landingpages', {
    icon: 'web',
    accessPrivilege: ['partner', 'licensee', 'mlg', 'landing_page', 'office_profi'],
});
export const ROUTE_ACCOUNT_LANDINGPAGES_OWNER = ROUTE_ACCOUNT_LANDINGPAGES.sub(':owner', 'account_landingpages_owner');
export const ROUTE_ACCOUNT_LANDINGPAGE_DETAILS = ROUTE_ACCOUNT_LANDINGPAGES_OWNER.sub(
    ':lp',
    'account_landingpage_details'
);
export const ROUTE_ACCOUNT_LANDINGPAGE_DETAILS_TABS = ROUTE_ACCOUNT_LANDINGPAGE_DETAILS.sub(
    ':tab',
    'account_landingpage_details_tabs'
);

/* Translations (R31-4: Zusatzrolle Übersetzer) */
export const ROUTE_ACCOUNT_TRANSLATIONS = ROUTE_ACCOUNT.sub('translations', 'account_translations', {
    icon: 'translate',
    accessPrivilege: ['translator'],
});

/* Downloads */
export const ROUTE_ACCOUNT_DOWNLOAD = ROUTE_ACCOUNT.sub('downloads', 'account_downloads', { icon: 'folder' });

export const ROUTE_ACCOUNT_DOWNLOAD_INFO_TOPIC = ROUTE_ACCOUNT_DOWNLOAD.sub(':topic', 'account_downloads_info_topic');
export const ROUTE_ACCOUNT_DOWNLOAD_INVOICE = ROUTE_ACCOUNT_DOWNLOAD.sub('invoices', 'account_downloads_invoice');
export const ROUTE_ACCOUNT_DOWNLOAD_COMMISSION = ROUTE_ACCOUNT_DOWNLOAD.sub(
    'commission-invoices',
    'account_downloads_commission'
);

/* Device Service */
export const ROUTE_ACCOUNT_SERVICE = ROUTE_ACCOUNT.sub('service', 'account_service', { icon: 'coffee_maker' });
export const ROUTE_ACCOUNT_SERVICE_DEVICE = ROUTE_ACCOUNT_SERVICE.sub('devices', 'account_service_device');

/* Calendar */
export const ROUTE_ACCOUNT_CALENDAR = ROUTE_ACCOUNT.sub('calendar', 'account_calendar', {
    icon: 'calendar_month',
    accessPrivilege: ['licensee', 'office_profi'],
});

/* Commission */
export const ROUTE_ACCOUNT_COMMISSION = ROUTE_ACCOUNT.sub('commission', 'account_commission', {
    icon: 'account_balance_wallet',
    accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg', 'referral_partner'],
});

export const ROUTE_ACCOUNT_COMMISSION_STATS = ROUTE_ACCOUNT_COMMISSION.sub('stats', 'account_commission_stats');

export const ROUTE_ACCOUNT_COMMISSION_CHART = ROUTE_ACCOUNT_COMMISSION.sub('chart', 'account_commission_chart');

/* Organization */
export const ROUTE_ACCOUNT_ORGANIZATION = ROUTE_ACCOUNT.sub('organization', 'account_organization', {
    icon: 'groups',
    accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
});

export const ROUTE_ACCOUNT_ORGANIZATION_OVERVIEW = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'overview',
    'account_organization_overview',
    {
        accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_CUSTOMERS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'customers',
    'account_organization_customers',
    {
        accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
    }
);
export const ROUTE_ACCOUNT_ORGANIZATION_SIS_PARTNERS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'sis-partners',
    'account_organization_sis_partners',
    {
        accessPrivilege: 'partner',
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_OFFICE_PROFIS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'office_profis',
    'account_organization_office_profis',
    {
        accessPrivilege: 'partner',
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_LICENSORS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'licensors',
    'account_organization_licensors',
    {
        accessPrivilege: 'mlg',
    }
);
export const ROUTE_ACCOUNT_ORGANIZATION_PLACEMENTS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'placements',
    'account_organization_placements'
);

/* Mitarbeiterchip */
export const ROUTE_ACCOUNT_CHIP = ROUTE_ACCOUNT.sub('chip', 'account_chip', {
    accessPrivilege: ['vending_admin', 'vending_customer', 'vending_viewer'],
});
export const ROUTE_ACCOUNT_CHIP_VERWALTUNG = ROUTE_ACCOUNT_CHIP.sub('verwaltung', 'account_chip_verwaltung', {
    accessPrivilege: ['vending_admin'],
});

/* Success List */
export const ROUTE_ACCOUNT_SUCCESS_LIST = ROUTE_ACCOUNT.sub('success-list', 'account_success_list', {
    icon: 'emoji_events',
    accessPrivilege: ['office_profi', 'partner', 'mlg'],
});

export const ROUTE_ACCOUNT_SUCCESS_LIST_OVERVIEW = ROUTE_ACCOUNT_SUCCESS_LIST.sub(
    'overview',
    'account_success_list_overview'
);

export const ROUTE_ACCOUNT_SUCCESS_LIST_TOPICS_GROUP = ROUTE_ACCOUNT_SUCCESS_LIST.sub(
    ':successListTopic',
    'account_success_list_topics'
);

// maybe deprecated?
export const ROUTE_ACCOUNT_ACADEMY = ROUTE_ACCOUNT.sub('academy', 'account_academy', {
    icon: 'school',
    accessPrivilege: 'partner',
});

/* R63 Mitarbeiterchip (Operator Kunde) — in the menu only while a chip is linked to the customer */
export const ROUTE_ACCOUNT_EMPLOYEE_CHIP = ROUTE_ACCOUNT.sub('chip', 'r63_vending.employee_chip', {
    icon: 'contactless',
});

/* R63 Operator / Standortverwaltung — in the menu only while linked as an operator / as a Standort's Kunde */
export const ROUTE_ACCOUNT_OPERATOR = ROUTE_ACCOUNT.sub('operator', 'r63_vending_pages.operator', {
    icon: 'engineering',
});
export const ROUTE_ACCOUNT_SITE = ROUTE_ACCOUNT.sub('site', 'r63_vending_pages.site', { icon: 'domain' });

/* Videos */
export const ROUTE_ACCOUNT_VIDEO = ROUTE_ACCOUNT.sub('video', 'account_video', { icon: 'play_circle' });

export const ROUTE_VIDEO_TOPICS_GROUP = ROUTE_ACCOUNT_VIDEO.sub(':videoTopic', 'video_topics');

/* Account Routes Group */
// R27-9: Nachrichten left the sidebar (the page stays reachable); R27-23: Organisation is ONE entry
export const GROUP_ACCOUNT = [
    ROUTE_ACCOUNT_DATA,
    ROUTE_ACCOUNT_ORDERS,
    ROUTE_ACCOUNT_DOWNLOAD,
    ROUTE_ACCOUNT_SERVICE,
    ROUTE_ACCOUNT_VIDEO,
    ROUTE_ACCOUNT_CALENDAR,
    ROUTE_ACCOUNT_ORGANIZATION,
    ROUTE_ACCOUNT_COMMISSION,
    ROUTE_ACCOUNT_LANDINGPAGES,
    ROUTE_ACCOUNT_TRANSLATIONS,
    ROUTE_ACCOUNT_EMPLOYEE_CHIP,
    ROUTE_ACCOUNT_OPERATOR,
    ROUTE_ACCOUNT_SITE,
];
